import { action } from '@ember/object';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import didUpdate from 'webapp/modifiers/did-update';
import FormInputComponent from 'webapp/components/form/input';
import FormTextareaComponent from 'webapp/components/form/textarea';

import type { BoardShare, ReportScheduleSetting } from 'webapp/models-custom';

interface Args {
	model: BoardShare | ReportScheduleSetting;
	submitInProgress: boolean;
}

export default class BoardsShareScheduleCustomSubjectAndNoteComponent extends Component<Args> {
	@tracked showNoteText = false;

	private currentModel!: BoardShare | ReportScheduleSetting;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.onModelChange();
	}

	get shownNoteText() {
		return this.showNoteText ? this.args.model.note : '';
	}

	set shownNoteText(value: string) {
		this.args.model.note = value;
	}

	@action
	onNoteFocusIn() {
		this.showNoteText = true;
	}

	@action
	onModelChange() {
		if (this.currentModel !== this.args.model) {
			this.showNoteText = !this.args.model.isNew || !this.args.model.isNoteDefault;
			this.currentModel = this.args.model;
		}
	}

	<template>
		<div class="row" {{didUpdate this.onModelChange @model}}>
			<FormInputComponent
				name="subject"
				@value={{@model.subject}}
				placeholder="Add a custom subject (optional)"
				disabled={{@submitInProgress}}
				@hideFloatLabel={{true}}
				maxlength="512"
			/>
		</div>

		<div class="row note">
			<FormTextareaComponent
				name="note"
				@value={{this.shownNoteText}}
				placeholder="Add a personal note (optional)"
				disabled={{@submitInProgress}}
				@hideFloatLabel={{true}}
				@focusIn={{this.onNoteFocusIn}}
				maxlength="5000"
			/>
		</div>
	</template>
}
